import React from "react";
import Header from "../menu/Header";
import Menu from "../menu/Menu";
import { useEffect, useState, useContext } from "react";
import { adminContext } from "../../../context/admincontext";
import Category from "./Category";
import Zones from "./Zones";
import Points from "./Points";
import MoreDes from "./MoreDes";
import Description from "./Description";
import Timing from "./Timing";
import Pricing from "./Pricing";

const AdminSetting = () => {
  const { setPage } = useContext(adminContext);
  const [tab, setTab] = useState(1);
  useEffect(() => {
    const fetchData = async () => {
      try {
        setPage("تنظیمات");
      } catch (err) {
        console.log(err);
      }
    };
    fetchData();
  }, []);
  return (
    <div style={{ paddingTop: "10px" }}>
      <Header />
      <div className="d-flex content-box">
        <Menu />
        <div
          className="w-100 me-lg-3 ms-lg-5 p-3"
          style={{
            background:
              "linear-gradient(180deg, #D9D9D9 0%, rgba(217, 217, 217, 0.00) 100%)",
            minHeight: "630px",
            borderRadius: "30px",
          }}
        >
          <div className="d-flex admin-setting-tab " >
            <button
            className={`btn ms-2  ${tab === 1 && "active"}`}
              onClick={() => {
                setTab(1);
              }}
            >
              دسته بندی ها
            </button>
            <button
            className={`btn ms-2 ${tab === 2 && "active"}`}
              onClick={() => {
                setTab(2);
              }}
            >
              مناطق
            </button>
            <button
            className={`btn ms-2 ${tab === 3 && "active"}`}
              onClick={() => {
                setTab(3);
              }}
            >
              امتیازات
            </button>
            <button
            className={`btn ms-2 ${tab === 4 && "active"}`}
              onClick={() => {
                setTab(4);
              }}
            >
              توضیحات بیشتر
            </button>
            <button
            className={`btn ms-2 ${tab === 5 && "active"}`}
              onClick={() => {
                setTab(5);
              }}
            >
              توضیحات 
            </button>
            <button
            className={`btn ms-2 ${tab === 6 && "active"}`}
              onClick={() => {
                setTab(6);
              }}
            >
              زمانبندی
            </button>
            <button
            className={`btn ms-2 ${tab === 7 && "active"}`}
              onClick={() => {
                setTab(7);
              }}
            >
              لیست قیمت
            </button>
          </div>
          <div className="mt-4">
          {
            tab === 1 ? <Category/>  : 
            tab === 2 ? <Zones/>  : 
            tab === 3 ? <Points/>  : 
            tab === 4 ? <MoreDes/>  : 
            tab === 5 ? <Description/>  : 
            tab === 6 ? <Timing/>  : 
            tab === 7 ? <Pricing/>  : ""
          }
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminSetting;
